import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderWidth1, colorBorderInput, space6 } = theme();

  return StyleSheet.create({
    container: {
      justifyContent: "flex-start",
      paddingBottom: space6,
      paddingHorizontal: 0,
    },
    feedbackContainer: {
      borderTopColor: colorBorderInput,
      borderTopWidth: borderWidth1,
      marginTop: space6,
      paddingTop: space6,
    },
    feedbackContainerMobile: {
      paddingHorizontal: space6,
    },
  });
};

export { style };
